module.exports = __webpack_public_path__ + "img/4.61e7fa71.png";